import { GrantSlackAccessMutationfs5xfcp7iisz as GrantSlackAccessMutation } from './schema/GrantSlackAccessMutation.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  Unauthorized_instance2jgb1jb3jobqz as Unauthorized_instance,
  Accepted_instance1051nmidder43 as Accepted_instance,
  Rejected_instances6p2tssc0jwo as Rejected_instance,
} from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Dispatchervu4hb3oerxrm as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantSlackAccessCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GrantSlackAccessInput3j0s7of1xul8d as GrantSlackAccessInput } from './schema/type/GrantSlackAccessInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_perform__v6ng8j($this, command, $completion) {
  var tmp = $this.o6q(new (GrantSlackAccessMutation())(grantSlackAccessInput(command)), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp.l44_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o6f_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toVoidResult(tmp1_safe_receiver);
  return tmp2_elvis_lhs == null ? Unauthorized_instance : tmp2_elvis_lhs;
}
function perform(command, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_perform__v6ng8j.bind(VOID, this, command), $completion);
}
var SdkGrantSlackAccessClass;
function SdkGrantSlackAccess() {
  if (SdkGrantSlackAccessClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkGrantSlackAccess', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkGrantSlackAccessClass = $;
  }
  return SdkGrantSlackAccessClass;
}
function toVoidResult(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4) {
    case true:
      tmp = Accepted_instance;
      break;
    case false:
      tmp = Rejected_instance;
      break;
    case null:
      tmp = Unauthorized_instance;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function grantSlackAccessInput(_this__u8e3s4) {
  return new (GrantSlackAccessInput())(_this__u8e3s4.t2j_1, _this__u8e3s4.u2j_1);
}
//region block: exports
export {
  SdkGrantSlackAccess as SdkGrantSlackAccess15ga4e1z55nsr,
  toVoidResult as toVoidResult8ga34bq1f52r,
  perform as perform1ygbfmihaa1i1,
};
//endregion

//# sourceMappingURL=SdkGrantSlackAccess.mjs.map
